import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/info-filled-blue.svg';
import Modal from '../../Modal/Modal';
import ModalBody from '../../Modal/ModalBody';
import SfhSecondaryButton from '../SellWizard/SfhSecondaryButton';
import { variables } from '../../../assets/styles/variables';
import themeColors from '../../../assets/styles/themeColors';

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

const BodyTitle = styled.h3`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: ${themeColors.colorTextSecondary};
  text-align: center;
`;

const PhoneLink = styled.a`
  display: block;
  margin-top: 16px;
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  text-align: center;
  text-decoration: underline;
  color: ${themeColors.colorPrimary};
`;

// Close CTA per design: Onest / 600 / 16px / 130% line-height in the SFH
// action blue. Builds on the shared SFH outlined button and overrides the
// font and text color (incl. interactive states) to the Figma spec.
const CloseButton = styled(SfhSecondaryButton)`
  && {
    width: 100%;
    margin-top: 16px;
    font-family: ${variables.family.goldSilverHeaders}, sans-serif;
    line-height: 1.3;
  }

  &&,
  &&:hover,
  &&:focus,
  &&:active {
    color: ${themeColors.colorSfhActionBlue};
  }
`;

const NonUSAccountRestrictionModal = ({ isOpen, close }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      maxWidth="320px"
      borderRadius="10px"
      close={close}
      hideHeader
      verticalCenter
      isCenterModal
      disableBlur
    >
      <ModalBody style={{ padding: '24px' }}>
        <IconWrapper>
          <InfoIcon width={35} height={35} />
        </IconWrapper>
        <BodyTitle>{t('portfolio.sellFromHome.nonUs.title')}</BodyTitle>
        <PhoneLink
          href={`tel:${t('portfolio.sellFromHome.nonUs.phoneNumber')}`}
        >
          {t('portfolio.sellFromHome.nonUs.needHelp')}{' '}
          {t('portfolio.sellFromHome.nonUs.phone')}
        </PhoneLink>
        <CloseButton onClick={close} data-cy="button-sfh-non-us-close">
          {t('common.close')}
        </CloseButton>
      </ModalBody>
    </Modal>
  );
};

NonUSAccountRestrictionModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
};

export default NonUSAccountRestrictionModal;
